module.exports = __webpack_public_path__ + "img/0x80A16016cC4A2E6a2CACA8a4a498b1699fF0f844.2a17ad98.png";